import { render, staticRenderFns } from "./TransferStats.vue?vue&type=template&id=dbcaabd0&"
import script from "./TransferStats.vue?vue&type=script&lang=js&"
export * from "./TransferStats.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports